/**
 * Header hero slider.
 *
 * Bundles only the Swiper core and the Navigation module to keep the
 * first-screen payload small. Sliders with a single slide are rendered
 * as a static image and never initialized.
 */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

const initHeaderSliders = () => {
	document.querySelectorAll( '.header-slider' ).forEach( ( root ) => {
		const container = root.querySelector( '.header-slider__swiper' );

		if ( ! container || container.swiper ) {
			return;
		}

		if ( container.querySelectorAll( '.swiper-slide' ).length < 2 ) {
			return;
		}

		return new Swiper( container, {
			modules: [ Navigation ],
			slidesPerView: 1,
			speed: 450,
			loop: true,
			navigation: {
				prevEl: root.querySelector( '.header-slider__arrow-prev' ),
				nextEl: root.querySelector( '.header-slider__arrow-next' ),
			},
		} );
	} );
};

if ( 'loading' === document.readyState ) {
	document.addEventListener( 'DOMContentLoaded', initHeaderSliders );
} else {
	initHeaderSliders();
}
